<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-[25px] mb-[25px]">
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/txt.png" class="inline-block" alt="txt-image">
            <h6 class="my-[18px] text-[15px]">
                Projects
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/pdf.png" class="inline-block" alt="pdf-image">
            <h6 class="my-[18px] text-[15px]">
                Documents
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/xl4.png" class="inline-block" alt="xl4-image">
            <h6 class="my-[18px] text-[15px]">
                Media
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/jpg.png" class="inline-block" alt="jpg-image">
            <h6 class="my-[18px] text-[15px]">
                Applications
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/png.png" class="inline-block" alt="png-image">
            <h6 class="my-[18px] text-[15px]">
                ET Template
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/jpg.png" class="inline-block" alt="jpg-image">
            <h6 class="my-[18px] text-[15px]">
                React Template
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/txt.png" class="inline-block" alt="txt-image">
            <h6 class="my-[18px] text-[15px]">
                Material UI
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/pdf.png" class="inline-block" alt="pdf-image">
            <h6 class="my-[18px] text-[15px]">
                WP Themes
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/xl4.png" class="inline-block" alt="xl4-image">
            <h6 class="my-[18px] text-[15px]">
                Personal Photos
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/doc.png" class="inline-block" alt="doc-image">
            <h6 class="my-[18px] text-[15px]">
                Mobile Apps
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/png.png" class="inline-block" alt="png-image">
            <h6 class="my-[18px] text-[15px]">
                Important Files
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/jpg.png" class="inline-block" alt="jpg-image">
            <h6 class="my-[18px] text-[15px]">
                Angular Template
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/txt.png" class="inline-block" alt="txt-image">
            <h6 class="my-[18px] text-[15px]">
                Projects
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/pdf.png" class="inline-block" alt="pdf-image">
            <h6 class="my-[18px] text-[15px]">
                Documents
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/xl4.png" class="inline-block" alt="xl4-image">
            <h6 class="my-[18px] text-[15px]">
                Media
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md text-center">
        <div class="trezo-card-content">
            <img src="@/assets/images/icons/jpg.png" class="inline-block" alt="jpg-image">
            <h6 class="my-[18px] text-[15px]">
                Applications
            </h6>
            <div class="flex justify-center items-center gap-[12px]">
                <button type="button" class="text-primary-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        visibility
                    </i>
                </button>
                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        edit
                    </i>
                </button>
                <button type="button" class="text-danger-500 leading-none">
                    <i class="material-symbols-outlined !text-md">
                        delete
                    </i>
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Documents",
});
</script>
